import useCommonModal from '@/compositions/useCommonModal';
import { useMutation } from '@vue/apollo-composable';
import gql from '@/api/objects/item.graphql';

import cloneDeep from 'lodash.clonedeep';
import { isJson } from '@/utils/getCurrentType';
import copy from 'copy-to-clipboard';
const useObjectActions = (props, context, entity) => {
  const modalComposition = useCommonModal();
  const { mutate: updateProperty } = useMutation(gql.updateObjectProperty);

  const handleSaveProperty = targetEntity => {
    let clone = cloneDeep(targetEntity);

    if (isJson(clone.typeId)) {
      clone.value = JSON.stringify(clone.value);
    }

    let schema = entity.result.value.object.schema.schemaProperties;
    let schemaOfProperty = schema.find(item => item.key === targetEntity.key);

    let valueSet = schemaOfProperty?.valueSet;
    let valueRange = schemaOfProperty?.valueRange;

    if (valueSet) {
      clone.valueSet = valueSet;
    }

    if (valueRange) {
      clone.valueRange = valueRange;
    }

    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'EditProperty'
      },
      slots: {
        default: {
          component: () =>
            import('@/components/app-entity/modals/EditProperty.vue'),
          bind: {
            currentItem: clone
          },
          on: {
            close() {
              modalComposition.modal.hide('EditProperty');
            }
          }
        }
      }
    });
  };

  const handleSetDefault = targetEntity => {
    let schema = entity.result.value.object.schema.schemaProperties;
    let defaultPropertyValue = schema.find(
      item => item.property === targetEntity.property
    );

    updateProperty({
      input: {
        id: targetEntity.id,
        patch: {
          value: defaultPropertyValue.defaultValue
        }
      }
    });
  };

  const handleSetNull = targetEntity => {
    updateProperty({
      input: {
        id: targetEntity.id,
        patch: {
          value: null
        }
      }
    });
  };

  const handleCopy = targetEntity => {
    copy(targetEntity.value, {
      format: 'text/plain'
    });
  };

  const handleLinkProperty = targetEntity => {
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'LinkProperty'
      },
      slots: {
        default: {
          component: () =>
            import('@/components/app-entity/modals/LinkProperty.vue'),
          bind: {
            entity: targetEntity
          },
          on: {
            close() {
              modalComposition.modal.hide('LinkProperty');
            }
          }
        }
      }
    });
  };

  const getActions = targetEntity => {
    return [
      {
        id: 'edit-property',
        text: 'Edit property',
        icon: 'mdi-pencil',
        handleAction: () => handleSaveProperty(targetEntity),
        _enabled: true
      },
      // {
      //   id: 'edit-meta-json',
      //   handleAction: async (item) => {
      //     const component = await import('@/components/app-entity/modals/EditMeta')
      //     console.log(component)
      //     modalComposition.handleOpen(component, { item })
      //   },
      //   text: 'Meta JSON',
      //   icon: 'mdi-code-tags',
      //   _enabled: true
      // },
      {
        id: 'copy',
        text: 'Copy',
        icon: 'mdi-image-filter-none',
        handleAction: () => handleCopy(targetEntity),
        _enabled: true
      },
      {
        id: 'set-property-default',
        text: 'Set default',
        icon: 'mdi-reply',
        handleAction: () => handleSetDefault(targetEntity),
        _enabled: true
      },
      {
        id: 'link-property',
        text: 'Link',
        icon: 'mdi-link-variant',
        handleAction: () => handleLinkProperty(targetEntity),
        _enabled: true
      },
      {
        id: 'set-property-null',
        text: 'Set null',
        icon: 'mdi-close',
        handleAction: () => handleSetNull(targetEntity),
        _enabled: true
      },
      {
        text: 'Show history',
        id: 'show-property-history',
        icon: 'mdi-history',
        _enabled: true
      }
    ];
  };

  return {
    getActions
  };
};

export default useObjectActions;
